module.exports = __webpack_public_path__ + "img/bell_5.f3bff63a.jpg";